/**
 * Detect touch-first/mobile browsers where iframe PDF viewing is unreliable.
 */
export const isMobileDevice = () => {
  if (typeof window === 'undefined') return false

  const userAgent = navigator.userAgent || ''
  const mobilePattern =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i

  return (
    mobilePattern.test(userAgent) ||
    (navigator.maxTouchPoints > 1 && window.innerWidth < 1024)
  )
}

/**
 * Open a PDF blob URL in the device's native viewer.
 * User-initiated clicks are required for Android blob URL handling.
 */
export const openPdfInNativeViewer = (blobUrl, fileName = 'proforma.pdf') => {
  const link = document.createElement('a')
  link.href = blobUrl
  link.target = '_blank'
  link.rel = 'noopener noreferrer'
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
